export default __webpack_public_path__ + "static/media/first1.d8edbd36.svg";